module.exports = __webpack_public_path__ + "static/img/i3.2704b31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i3.png
// module id = MjLz
// module chunks = 0